<template>
  <div>
    <!-- <FormItem label="服务名">
      <Input placeholder="请输入" v-model="table2.search.ServiceName"></Input>
    </FormItem> -->
      <!-- <Form :label-width="100" inline>
        <FormItem label="" >
            <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
            <Button class="mr-3" type="success" @click="search_fuwu">查询</Button>
        </FormItem>
      </Form> -->
    <div class="ml-3">
      <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
      <Button class="mr-3" type="success" @click="search_fuwu">查询</Button>
    </div>
    <DataTable
      class="mb-5"
      ref="dataTable2"
      :columns="table2.columns"
      :apiUrl="table2.apiUrl"
      :search="table2.search"
    ></DataTable>
    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientXmladd @close="addModal = false" @loadData="search" @search_fuwu="search_fuwu"></clientXmladd>
    </Modal>

    <!--编辑-->
    <Modal
      v-model="editModal"
      title="编辑"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientXmledit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        @search_fuwu="search_fuwu"
        :currentData="currentData"
      ></clientXmledit>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import clientXmladd from "../clientXml/add.vue";
import clientXmledit from "../clientXml/edit.vue";

export default {
  props: ["clientSN"],
  components: {
    DataTable,
    clientXmladd,
    clientXmledit,
  },
  data: function () {
    return {
      parmTitleSelect: [],
      currentData: {},
      addModal: false,
      editModal: false,
      table:{
        search:{ServiceName:''}
      },
      table2: {
        columns: [
          {
            title: "服务名",
            key: "parmTitle",
            width: "180px",
            render: (h, params) =>
              h("span", {}, this.findServerName(params.row.parmTitle)),
          },
          { title: "类型", key: "parmType", width: "60px" },
          // { title: "键", key: "parmName" },
          { title: "值", key: "parmValue", tooltip: true },
          {
            title: "启用状态",
            key: "statusName",
          },
          {
            title: "更新状态",
            key: "updateName",
          },
          {
            title: "操作",
            width: "280px",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.clientParameterID);
                      },
                    },
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.status == 0 ? "error" : "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.SwitchState(params.row, params.row.status ^ 1);
                      },
                    },
                  },
                  params.row.status == 0 ? "关闭" : "启用"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.isUpdate == 0 ? "primary" : "error",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.SwitchUpdate(params.row, params.row.isUpdate ^ 1);
                      },
                    },
                  },
                  params.row.isUpdate == 0 ? "设置已更新" : "设置未更新"
                ),
              ]);
            },
          },
        ],
        apiUrl: "clientXml/getList?", //+ (this.clientSN ? this.clientSN : ""),
        search: {
          ServiceName:'',
          ClientSN: this.clientSN ? this.clientSN : "",
        },
      },
    };
  },

  mounted() {
    this.getXmlServiceNameList();
    this.table2.search.ClientSN = this.clientSN;
    this.$refs.dataTable2.initload();
  },
  watch: {
    clientSN: function (val, oldVal) {
        
      this.table2.search.ClientSN = val;
      this.$refs.dataTable2.initload();
      //   console.log("new: %s, old: %s", val, oldVal);
    },
  },
  methods: {
    search_fuwu(){
      this.$refs.dataTable2.initload();
    },
    findServerName(code) {
      var obj = this.parmTitleSelect.find((p) => p.dictionaryCode == code);
      if (obj) {
        return obj.dictionaryValue;
      } else {
        return "";
      }
    },
    ConvertStatus(code) {
      switch (code) {
        case 0:
          return "启动";
        case 1:
          return "关闭";
        // case 2:
        //   return "重启";
        default:
          return "启动";
      }
    },

    search: function () {
      this.$refs.dataTable.initload();
    },
    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
      let name = this.currentData.parmTitle;
      this.currentData.parmTitle = this.findServerName(name);
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "是否删除这条配置项？",
        mask: false,
        onOk: () => {
          this.$api.post(`/clientXml/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              // this.search();
              this.search_fuwu();
              this.$Message.success("删除成功");
            }
          });
        },
      });
    },

    getXmlServiceNameList() {
      this.$common.getDictionaryByCode("9001").then((data) => {
        this.parmTitleSelect = data;
      });
    },

    // onRowClick(data) {
    //   this.isShowDataTable2 = true;
    //   this.table2.search.clientSN = data.clientSN;
    //   if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
    // },
    SwitchState(data, status) {
      var parm = {
        ClientParameterID: data.clientParameterID,
        Status: status,
      };

      this.$api.post(`/clientXml/SwitchState`, parm).then((rsp) => {
        if (rsp.statusCode == 200) {
          this.$Message.success(rsp.msg);
          this.table2.search.clientSN = data.clientSN;
          if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
        } else {
          this.$Message.success(rsp.msg);
        }
      });
    },
    SwitchUpdate(data, status) {
      var parm = {
        ClientParameterID: data.clientParameterID,
        Status: status,
      };

      this.$api.post(`/clientXml/SwitchUpdate`, parm).then((rsp) => {
        if (rsp.statusCode == 200) {
          this.$Message.success(rsp.msg);
          this.table2.search.clientSN = data.clientSN;
          if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
        } else {
          this.$Message.success(rsp.msg);
        }
      });
    },
  },
};
</script>
